import styled from 'styled-components';
import { Form } from 'react-bootstrap';

export const DocumentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  align-items: flex-start;
`;

export const CustomSelect = styled(Form.Select)`
  padding: 2px 0px 2px 10px;
  border-radius: 50px !important;
  color: rgba(244, 241, 222, 0.8);
  font-style: italic;
  background: rgba(26, 26, 46, 0.1);
  border: 1px solid rgba(244, 241, 222, 0.2);
  backdrop-filter: blur(10px);
  
  &:focus {
    border-color: rgba(244, 241, 222, 0.4);
    box-shadow: 0 0 0 0.2rem rgba(244, 241, 222, 0.1);
  }
`;

export const Subtitle = styled.div`
  font-size: 15px;
  color: rgba(244, 241, 222, 0.7);
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
`;

export const HorizontalSplit = styled.div`
  height: 2px;
  background: linear-gradient(90deg, rgba(244, 241, 222, 0.2) 0%, rgba(244, 241, 222, 0.1) 50%, rgba(244, 241, 222, 0.05) 100%);
  margin-top: 5px;
  width: 100%;
  border-radius: 1px;
`;

export const BranchsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: flex-start;
`;

// Botão de ação com layout similar ao CustomButton usado em outras páginas
export const ExportActionButton = styled.button`
  border: 1px solid #6c757d;
  color: #6c757d;
  background: #ffffff;
  font-weight: 500;
  border-radius: 6px;
  padding: 8px 12px;
  transition: all 0.2s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 14px;
  position: relative;
  z-index: 10;

  &:hover {
    background: #6c757d;
    color: #ffffff;
    border-color: #6c757d;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.25);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    
    &:hover {
      background: #ffffff;
      color: #6c757d;
      border-color: #6c757d;
      transform: none;
    }
  }
`;
